import { useEffect } from 'react';

import type { ProductTypeEnum } from '@snowit/models';

import { useRouter } from '@snowit/wouter';

import s from './WidgetPreview.module.scss';

type FormType = {
  tenant: string;
  tabs?: ProductTypeEnum[];
  tab?: ProductTypeEnum;
  location?: string;
  locationUID?: string;
  mode?: 'mobile' | 'buttons' | 'buttons-mobile';
  partner?: string;
  client?: string;
  label?: string;
  sublabel?: string;
  domain?: string;
};

const script = document.createElement('script');
script.async = true;
const WidgetPreview = () => {
  const { useQuery } = useRouter();
  const query = useQuery<FormType>();

  useEffect(() => {
    script.src = `https://${query.domain ?? 'snowit.ski'}/ews/widget.js?${Date.now()}`;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [query]);

  return (
    <div className={s.wrapper}>
      <div className={s.container}>
        <div
          id='snowit-widget'
          data-tab={query.tab || undefined}
          data-tabs={query.tabs?.length ? query.tabs.join(',') : undefined}
          data-mode={query.mode || undefined}
          data-location={query.location || undefined}
          data-partner={query.partner || undefined}
          data-client={query.client || undefined}
          data-label={query.label || undefined}
          data-sublabel={query.sublabel || undefined}
        />
      </div>
    </div>
  );
};

export default WidgetPreview;
